import { ActionContext } from 'vuex';

import { CrudDataTypeEnum } from '../../../enums';

import { ActionClass, CrudState, Dictionary, Filter, Pagination, Sort } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';
import { CRUD_CONSTS } from '../../../store/crud/crud.consts';

export class ListAction implements ActionClass {

  public static async execute({ commit, dispatch, rootGetters }: ActionContext<CrudState, any>,
    payload: {
      dataType: CrudDataTypeEnum, pagination: Pagination, sort: Sort, requestFilters?: any, query?: string, strictMatching?: boolean
    }): Promise<any> {
    commit(CRUD_CONSTS.mutations.setState, {
      dataType: payload.dataType,
      data: [],
      pagination: {
        ...payload.pagination,
        totalItems: 0
      },
      sort: payload.sort
    });

    const enabledFilters: Dictionary<Filter> = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.enabledFilters }`];
    try {
      const response = await dispatch(CRUD_CONSTS.actions.fetchData, {
        dataType: payload.dataType,
        filters: enabledFilters,
        requestFilters: payload.requestFilters,
        pagination: payload.pagination,
        sort: payload.sort,
        query: payload.query,
        strictMatching: payload.strictMatching
      });
      const responseData = response.data;
      commit(CRUD_CONSTS.mutations.setState, {
        data: responseData.items,
        pagination: {
          ...payload.pagination,
          totalItems: responseData.total
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

}
